import { MapView } from 'cd-eft/utils/esriTypes';

class MapViewHighlightSuspender {
  private mapView: MapView;
  private originalHighlightOptions: __esri.MapViewHighlightOptions;

  /**
   *
   */
  constructor(mapView: MapView) {
    this.mapView = mapView;
    this.originalHighlightOptions = this.mapView.highlightOptions;
  }

  start() {
    this.mapView.highlightOptions = { haloOpacity: 0, fillOpacity: 0 };
  }

  stop() {
    this.mapView.highlightOptions = this.originalHighlightOptions;
  }
}

export { MapViewHighlightSuspender };
